import React from "react";
import { CreditorCases } from "us.collection.creditor/components/CreditorCases";

const Cnt_EditCreditorInfo: React.FC = (props) => {
  return <CreditorCases {...props} />;
};

export default Cnt_EditCreditorInfo;
